export const CONTACTUS_LIST_REQUEST = "CONTACTUS_LIST_REQUEST";
export const CONTACTUS_LIST_SUCCESS = "CONTACTUS_LIST_SUCCESS";
export const CONTACTUS_LIST_FAIL = "CONTACTUS_LIST_FAIL";

export const CONTACTUS_UPDATE_REQUEST = "CONTACTUS_UPDATE_REQUEST";
export const CONTACTUS_UPDATE_SUCCESS = "CONTACTUS_UPDATE_SUCCESS";
export const CONTACTUS_UPDATE_FAIL = "CONTACTUS_UPDATE_FAIL";
export const CONTACTUS_UPDATE_RESET = "CONTACTUS_UPDATE_RESET";
